import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';


const setValidation = (state, {payload}) => {
  return {
      ...state,
        status: true,
        message: payload
  };
};
const clearValidation = () =>{
  return {
    status: false,
    message: ''
  }
}

const initialState = {
    status: false
};

export default createReducer(initialState, {
  [TYPES.SET_VALIDATION]: setValidation,
  [TYPES.CLEAR_VALIDATION]:clearValidation
});
